import { BigNumber, BigNumberish } from 'ethers'

export class SimpleFraction {
	private readonly numerator: BigNumber

	private readonly denominator: BigNumber

	constructor(
		numerator: BigNumberish,
		denominator: BigNumberish = BigNumber.from(1)
	) {
		this.numerator = BigNumber.from(numerator)
		this.denominator = BigNumber.from(denominator)
	}

	add(value: SimpleFraction | BigNumberish): SimpleFraction {
		const fraction = this.toFraction(value)

		if (this.denominator.eq(fraction.denominator)) {
			return new SimpleFraction(
				this.numerator.add(fraction.numerator),
				this.denominator
			)
		}

		return new SimpleFraction(
			this.numerator
				.mul(fraction.denominator)
				.add(fraction.numerator.mul(this.denominator)),
			this.denominator.mul(fraction.denominator)
		)
	}

	mul(value: SimpleFraction | BigNumberish): SimpleFraction {
		const fraction = this.toFraction(value)

		return new SimpleFraction(
			this.numerator.mul(fraction.numerator),
			this.denominator.mul(fraction.denominator)
		)
	}

	div(value: SimpleFraction | BigNumberish): SimpleFraction {
		const fraction = this.toFraction(value)

		return new SimpleFraction(
			this.numerator.mul(fraction.denominator),
			this.denominator.mul(fraction.numerator)
		)
	}

	toBigNumber(): BigNumber {
		return this.numerator.div(this.denominator)
	}

	private toFraction(value: SimpleFraction | BigNumberish): SimpleFraction {
		if (value instanceof SimpleFraction) {
			return value
		}

		return new SimpleFraction(BigNumber.from(value))
	}
}
